<template>
  <div class="pa-12" v-if="items">
    <v-col cols="12">
      <v-row>
        <v-col cols="4" v-for="item in items" :key="item.id">
          <v-card light>
            <v-card-title>{{ item.doc.title }}</v-card-title>
            <v-card-text>
              <div class="preview mb-4">
                <img class="" :src="item.doc.src" />
              </div>
              <v-row>
                <v-col cols="6">
                  <h4 class="overline">Emotion</h4>
                  <p class="pa-0 mb-2 lh-0 text-h5">{{ item.doc.emotion }}</p>
                  <h4 class="overline">Super Power</h4>
                  <p class="pa-0 mb-2 lh-0 text-h5">
                    {{ item.doc.power }}
                  </p>
                </v-col>

                <v-col cols="6">
                  <h4 class="overline">Characteristics</h4>
                  <ul>
                    <li
                      v-for="(tag, index) in item.doc.attributes"
                      :key="index"
                      class="ma-1"
                    >
                      {{ tag }}
                    </li>
                  </ul>
                </v-col>

                <v-col cols="12">
                  <h4 class="overline">In a sentence</h4>
                  <p
                    v-if="item.doc.summary"
                    class="text-body-1"
                    v-html="item.doc.summary"
                  ></p>
                  <p v-else>
                    Press the 'Summarise' button to generate a summary
                  </p>
                  <v-btn
                    color="white"
                    @click="generateSummary(item)"
                    :disabled="loading"
                    >Summarise</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text></v-card
          >
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
// import lodash from "lodash";
import axios from "axios";
const fb = require("@/firebaseConfig.js");

import { mapState } from "vuex";

export default {
  name: "ResultsMuseumSummary",
  data() {
    return {
      items: null,
      cols: 4,
      messages: [],
      loading: false,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.getExercise(this.id);
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise(id) {
      this.items = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.museumExCollection.where("pid", "==", id);

      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.items = items;
          }
        })
        .catch(function() {});
    },
    async updateItem(item, content) {
      const docRef = fb.museumExCollection.doc(item.id);

      const uid = item.uid;
      const id = item.id;
      const refDoc = { ...item.doc };
      refDoc["summary"] = content;

      docRef
        .set({
          updatedOn: new Date(),
          id: id,
          uid: uid,
          pid: this.currentProjectModel.id,
          doc: refDoc,
        })
        .then(() => {
          this.getExercise(this.id);
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    async generateSummary(item) {
      if (!item.doc) return;
      this.loading = true;
      const content = [];
      const messages = [];
      content.push(
        "Summarise the following characteristics into a short succinct sentence and how it might behave as a brand"
      );
      content.push(item.doc.title);
      content.push(item.doc.emotion);
      content.push(item.doc.power);
      const attributes = item.doc.attributes.join(",");
      content.push(attributes);
      console.log("content", content);

      // // Add user's message to the chat
      messages.push({ role: "user", content: content.join(",") });

      try {
        // Send the user's message to the Express server
        const response = await axios.post(
          "https://chat.makelemonade.uk/api/chat",
          {
            messages: messages,
          }
        );

        // Add ChatGPT's response to the chat
        const assistantMessage = response.data.choices[0].message;
        this.updateItem(item, assistantMessage.content);
        this.loading = false;
      } catch (error) {
        console.error("Error communicating with the server:", error);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped="">
.preview {
  width: 100%;
  height: 20rem;
  position: relative;
  padding: 1rem;
  background: #f3f3f3;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
